module.exports = {
  "interval": 80,
  "frames": [
    "   ⠋",
    "   ⠙",
    "   ⠹",
    "   ⠸",
    "   ⠼",
    "   ⠴",
    "   ⠦",
    "   ⠧",
    "   ⠇",
    "   ⠏"
  ]
};




//////////////////
// WEBPACK FOOTER
// ./packages/truffle-reporters/reporters/migrations-V5/indentedSpinner.js
// module id = 2780
// module chunks = 0 1